
export const BEDROOM = 'bedroom';

export const BEDROOM_NORTH = 'bedroom-north';

export const BEDROOM_SOUTH = 'bedroom-south';

export const CALL = 'call';

export const FARENHEIGHT = 'f';

export const KITCHEN = 'kitchen';

export const LIVING_ROOM = 'living-room';

export const MINUTE = 'minute';

export const OFFICE = 'office';

export const OUTSIDE = 'outside';

export const PERCENTAGE = '%';

export const LOCATIONS = [BEDROOM_NORTH, BEDROOM_SOUTH, KITCHEN, LIVING_ROOM, OFFICE, OUTSIDE]

export const RADIANT_PIN = 26;

export const RECIRC_CLOSE_PIN = 5;

export const RECIRC_OPEN_PIN = 16;

export const SETTING_FRESH_AIR = 'fresh-air';

export const SETTING_TEMP = 'temperature';

export const MESSAGE = 'message';

export const CommunicationDirectionMap = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
} as const;

export type CommunicationDirection = typeof CommunicationDirectionMap[keyof typeof CommunicationDirectionMap];

export const CommunicationDirections = Object.values(CommunicationDirectionMap);

export interface DesiredSetting {

  amount: number;

  auto: boolean;
  
  name: string;
  
  timestamp: number;

  unit: string;

}

export interface FreshAirTimeEntry {

  finished_epoch: number;

  started_epoch: number;

  time_minutes: number; // minutes

}

export interface ReadingInterface { 
  reading_id: string, 
  sensor_id: string, 
  temp_c: number, 
  temp_f: number, 
  timestamp: number 
}

export class Reading implements ReadingInterface {

  reading_id: string;

  sensor_id: string;

  temp_c: number;

  temp_f: number;

  timestamp: number;

  constructor(input: Partial<Reading>) {

    if (input.reading_id) this.reading_id = input.reading_id;
    if (input.sensor_id) this.sensor_id = input.sensor_id;
    if (input.temp_c) this.temp_c = input.temp_c;
    if (input.temp_f) this.temp_f = input.temp_f;
    if (input.timestamp) this.timestamp = input.timestamp;

  }

}

export interface SensorReadingMap {

  [sensor_id: string]: number;

}

export interface LocationReadingMap {

  [location: string]: Reading;

}

export interface SensorInterface {
  location: string, 
  sensor_id: string,
}

export class Sensor implements SensorInterface {

  location: string;

  sensor_id: string;

  constructor(input: Partial<Sensor>) {

    if (input.location) this.location = input.location;
    if (input.sensor_id) this.sensor_id = input.sensor_id;

  }

}